var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 8.99994V12.7499M2.69702 16.1256C1.83163 17.6256 2.9142 19.4999 4.64593 19.4999H19.3546C21.0863 19.4999 22.1689 17.6256 21.3035 16.1256L13.9492 3.37807C13.0833 1.87723 10.9172 1.87723 10.0513 3.37807L2.69702 16.1256ZM12.0003 15.7499H12.0078V15.7574H12.0003V15.7499Z",
    stroke: "#D47F00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightWarn);
export default __webpack_public_path__ + "static/media/light-warn.c490b6a46f8716e5fe87aff22fdb9bca.svg";
export { ForwardRef as ReactComponent };